<template>
  <div class="tx-products module-search-result">
    <a class="result__link" :href="result.link">
      <div class="product-image__wrapper" v-if="result.image">
        <div class="image__container">
          <img :src="`${result.image.split('|')[0]}`" :alt="`${result.title} picture`">
        </div>
        <div class="product-image__badge" v-if="result.new">
          <span>{{ $t('productList.result.new') }}</span>
        </div>
        <div class="product-image__badge--badge" v-if="result.badge">
          <img :src="`${result.badge.split('|')[0]}`" :alt="`${result.title} picture`">
        </div>
      </div>
      <div class="product-text__wrapper">
        <div class="product-title__wrapper">
          <div class="product_title">
            <span class="heading epsilon">{{ result.title }}</span>
          </div>
          <div class="product_subtitle">
            <span>{{ result.shortDescription }}</span>
          </div>
        </div>
        <div class="product-info__wrapper">
          <div class="content__wrapper" v-if="result.comfort">
            <div class="comfort__text">
              <span>{{ $t('productList.result.comfort') }}</span>
            </div>
            <div class="comfort__content">
              <span v-if="result.mixedComfort" class="comfort-ranking__up-to">{{ $t('productList.result.comfortMixed') }}</span>
              <div class="comfort-ranking">
                <div class="comfort-ranking-filled" :style="'width: '+result.comfortPercentage+'%'"></div>
              </div>
            </div>
          </div>
          <div class="content__wrapper" v-if="result.thickness">
            <div class="thickness__text">
              <span>{{ $t('productList.result.thickness') }}</span>
            </div>
            <div class="thickness__content">
              <span>{{ result.thickness }}</span>
            </div>
          </div>
          <div class="content__wrapper" v-if="result.mainCategories && Object.keys(result.mainCategories).length > 0">
            <div class="suitable__text">
              <span>{{ $t('productList.result.suitable') }}</span>
            </div>
            <div class="suitable__content">
              <span>{{ suitables() }}</span>
            </div>
          </div>
        </div>
      </div>
    </a>
  </div>
</template>

<script>

export default {
  name: 'SearchResult',
  props: {
    result: {
      type: Object,
      default: () => {}
    }
  },
  methods: {
    suitables: function () {
      let suitableCats = []
      let suitableForCategories = []
      if (this.result.suitableForCategories) {
        suitableForCategories = Object.values(this.result.suitableForCategories)
      }
      // suitableForCategories.length > 0 -> belmondo + current page is not /products page
      // before: window.app.product_list.currentPage !== window.app.product_list.listPid && suitableForCategories.length > 0
      if (suitableForCategories.length > 0) {
        suitableCats = suitableForCategories
      } else {
        suitableCats = Object.values(this.result.mainCategories)
      }

      let suitablesString = ''
      for (let i = 0; i < suitableCats.length; i++) {
        suitablesString += suitableCats[i].title
        if (i + 1 < suitableCats.length) {
          suitablesString += ', '
        }
      }
      return suitablesString
    }
  }
}
</script>
